import React,{ useState,useEffect,forwardRef,useImperativeHandle } from 'react'
import { Modal,Form,Input,Radio,message } from 'antd';
import { saveAccount } from "@/services/account"
import { saveCustomerService } from "@/services/customerService";
import { ResDataType } from '@/services/ajax';
import { DataType } from '../column';
import { roleList,accountStatusList } from '@/constant';
const AccountContent = forwardRef<any,{ save:()=>void,fromPage?:string }>((props,ref) => {
    const { save,fromPage } = props;
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [curType,setCurType] = useState('');
    const [curAccount,setCurAccount] = useState<DataType>();

    const showModal = (type:string,row:DataType) => {
        setCurType(type);
        setCurAccount(row);
        if(type=='edit') {
            // const {userName,mobile,role,disable} = row;
            form.setFieldsValue(row) 
        } else {
            form.resetFields();
            fromPage ? form.setFieldsValue({disable:false}) :
            form.setFieldsValue({role:'Merchant',disable:false}) 
        }
        setIsModalOpen(true);
    };
    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            const data = {...values,id:curType=='add'? 0 :curAccount?.id};
            const res = await (fromPage ? saveCustomerService(data) : saveAccount(data)) as ResDataType; 
            console.log('Success:', res);
            if (res.code == 0) {
                message.success('保存成功');
                setIsModalOpen(false); 
                save();
            }else {
                message.error(res.message);
            }
        } catch (errorInfo) {
            console.log('Failed:', errorInfo); 
        } 
    }
    const handleCancel = () => {
        setIsModalOpen(false);
      };
      const otherFormItem = [{
        name:'role',
        label:'角色',
        requireText:'请选择角色',
        values:roleList
    }]
    const formItem = [
    {
        name:'userName',
        label:'账户名称',
        requireText:'请输入账户名称'
    },{
        name:'password',
        label:'账户密码',
        requireText:'请输入账户密码'
    },{
        name:'mobile',
        label:'手机号',
        requireText:'请输入手机号'
    },
    ...(fromPage? [] : otherFormItem),
    {
        name:'disable',
        label:'状态',
        requireText:'请选择账户状态',
        values:accountStatusList
    }]

    useImperativeHandle(ref, () => ({
        open: (type:string,row:DataType) => showModal(type,row),
    }))
    return(
        <Modal maskClosable={false} title={`${curType == 'add'?'新增':'编辑'}${fromPage ? '客服账户' : '账户'}`} okText="确定" cancelText="取消" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} >
            <Form
                form={form}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 14 }}
                layout="horizontal"
                style={{ maxWidth: 600 }}
                >
                    {
                        formItem.map((item)=> {
                            if(item.values) {
                                return <Form.Item label={item.label} name={item.name} key={item.name} rules={[{ required: true, message: item.requireText }]}>
                                    <Radio.Group>
                                        {item.values.map((item:{value:string | boolean,label:string},index:number)=> {
                                            return <Radio value={item.value} key={item.label+index}>{item.label}</Radio>
                                        })} 
                                    </Radio.Group>
                                </Form.Item>
                            } else {
                                return (
                                        ((item.name != 'password' && curType == 'edit') || curType == 'add') && (
                                            <Form.Item label={item.label} name={item.name} key={item.name} rules={[{ required: true, message: item.requireText }]}>
                                            <Input placeholder={item.requireText} /> 
                                        </Form.Item>
                                        )
                                )
                            }
                        })
                    }
            </Form>
        </Modal>
    )
})

export default AccountContent